import { EditingInputOnClick } from 'components/EditingInput'
import { useKestrelViewerContext } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import React, { CSSProperties } from 'react'
import { KVMeasurement } from 'types'

export const MeasurementLabelInput: React.FC<{
  selectedMeasurement: KVMeasurement
}> = ({ selectedMeasurement }) => {
  const { updateMeasurement } = useKestrelViewerContext()

  const setLabel = (s: string) => {
    updateMeasurement(
      selectedMeasurement,
      'measurementLabel',
      (a) => {
        a.label = s
        return a
      },
      s
    )
  }

  const divStyles = {
    textAlign: 'left',
    fontSize: '20px',
    padding: '3px',
    margin: '0 0 -2px',
    cursor: 'text',
  } as CSSProperties
  const inputStyles = { fontSize: '20px', padding: '2px' } as CSSProperties

  return (
    <EditingInputOnClick
      key={selectedMeasurement.id}
      divStyle={divStyles}
      inputStyle={inputStyles}
      value={selectedMeasurement.label}
      setValue={setLabel}
    />
  )
}
